import {BagMetric, BinMetric, CartMetric, InductPackageMetric, Resource, StowPackageMetric} from "../enums";
import {CYCLE, CYCLE_ID, ERROR_METRIC_SUFFFIX, True} from "../constants";
import {publishCount, publishTime} from "../MetricUtility";
import {
    getNodeResourceData,
    getStowBagMetrics,
    getStowBinMetricsForStowV2,
    getStowPackageMetrics,
    getStowCartMetrics
} from "../resources/StowResource";
import {getInductPackageMetrics} from "../resources/InductResource";

const metricProcessName = "SCC_STOW_FLOOR_LOCATION_V2";

export const LOAD_FLOOR_LOCATION_V2_METRICS_CALL_BEGIN = "LOAD_FLOOR_LOCATION_V2_METRICS_CALL_BEGIN";
export const LOAD_FLOOR_LOCATION_V2_METRICS_CALL_FAILURE = "LOAD_FLOOR_LOCATION_V2_METRICS_CALL_FAILURE";
export const LOAD_STOW_PACKAGE_METRICS_FOR_FLOOR_LOCATION_V2 = "LOAD_STOW_PACKAGE_METRICS_FOR_FLOOR_LOCATION_V2";
export const LOAD_INDUCT_PACKAGE_METRICS_FOR_FLOOR_LOCATION_V2 = "LOAD_STOW_PACKAGE_METRICS_FOR_FLOOR_LOCATION_V2";
export const LOAD_STOW_CART_METRICS_FOR_FLOOR_LOCATION_V2 = "LOAD_STOW_CART_METRICS_FOR_FLOOR_LOCATION_V2";
export const LOAD_STOW_BAG_METRICS_FOR_FLOOR_LOCATION_V2 = "LOAD_STOW_BAG_METRICS_FOR_FLOOR_LOCATION_V2";
export const LOAD_NODE_RESOURCE_DATA_FOR_FLOOR_LOCATION_V2 = "LOAD_NODE_RESOURCE_DATA_FOR_FLOOR_LOCATION_V2";
export const LOAD_STOW_BIN_METRICS_FOR_FLOOR_LOCATION_V2 = "LOAD_STOW_BIN_METRICS_FOR_FLOOR_LOCATION_V2";

const loadMetricsForFloorLocationCallBegin = () => ({
    type: LOAD_FLOOR_LOCATION_V2_METRICS_CALL_BEGIN
});

const loadStowPackageMetricsForFloorLocation = (stowPackageMetricsMap) => ({
    type: LOAD_STOW_PACKAGE_METRICS_FOR_FLOOR_LOCATION_V2,
    stowPackageMetricsMap
});

const loadInductPackageMetricsForFloorLocation = (stowPackageMetricsMap) => ({
    type: LOAD_INDUCT_PACKAGE_METRICS_FOR_FLOOR_LOCATION_V2,
    stowPackageMetricsMap
});

const loadStowCartMetricsForFloorLocation = (stowCartMetricsMap) => ({
    type: LOAD_STOW_CART_METRICS_FOR_FLOOR_LOCATION_V2,
    stowCartMetricsMap
});

const loadStowBagMetricsForFloorLocation = (stowBagMetricsMap) => ({
    type: LOAD_STOW_BAG_METRICS_FOR_FLOOR_LOCATION_V2,
    stowBagMetricsMap
});

const loadNodeResourceDataForFloorLocation = (nodeResourceData) => ({
    type : LOAD_NODE_RESOURCE_DATA_FOR_FLOOR_LOCATION_V2,
    nodeResourceData
});

const loadStowBinMetricsForFloorLocation = (stowBinMetricsMap) => ({
    type : LOAD_STOW_BIN_METRICS_FOR_FLOOR_LOCATION_V2,
    stowBinMetricsMap
});

const loadMetricsForFloorLocationCallFailure = () => ({
    type: LOAD_FLOOR_LOCATION_V2_METRICS_CALL_FAILURE
});


export const getStowPackageMetricsForFloorLocationV2 = (nodeId, cycles, aisles, cycleIds) => {
    const metricName = "getStowPackageMetrics";

    const request = {
        groupBy: Resource.FLOOR_LOCATION_V2,
        filters: {
            NODE: [nodeId],
            AISLE: aisles
        },
        metrics: [
            StowPackageMetric.STOWED_COUNT,
            StowPackageMetric.PLANNED_COUNT,
            StowPackageMetric.CURRENT_INDUCTED_COUNT
        ]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForFloorLocationCallBegin());
            const startTime = Date.now();
            const stowPackageMetricsMap = await getStowPackageMetrics(request);
            if (stowPackageMetricsMap) {
                dispatch(loadStowPackageMetricsForFloorLocation(stowPackageMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForFloorLocationCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForFloorLocationCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getInductPackageMetricsForFloorLocation = (nodeId, cycles, aisles) => {
    const metricName = "getInductPackageMetrics";

    const request = {
        nodeId: nodeId,
        groupBy: "FloorLocation",
        metricList: [InductPackageMetric.RECEIVED],
        filters: {
            Aisle: aisles
        }
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters["Cycle"] = cycles;
    }
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForFloorLocationCallBegin());
            const startTime = Date.now();
            const inductPackageMetricsMap = await getInductPackageMetrics(request);
            if (inductPackageMetricsMap) {
                dispatch(loadInductPackageMetricsForFloorLocation(inductPackageMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForFloorLocationCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForFloorLocationCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getStowCartMetricsForFloorLocation = (nodeId, cycles, aisles, cycleIds, isStowBreakdownV2Enabled) => {

    const metricName = "getStowCartMetrics";

    const request = {
        groupBy: Resource.FLOOR_LOCATION_V2,
        filters: {
            NODE: [nodeId],
            AISLE: aisles,
        },
        metrics: [
            CartMetric.PLANNED_CART_COUNT,
            CartMetric.OPEN_CART_COUNT,
            CartMetric.MISSING_CART_COUNT
        ]
    }

    if (isStowBreakdownV2Enabled) {
        request.filters["STOW_BREAKDOWN_V2"] = [True]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForFloorLocationCallBegin());
            const startTime = Date.now();
            let stowCartMetricsMap = await getStowCartMetrics(request);

            if (stowCartMetricsMap) {
                dispatch(loadStowCartMetricsForFloorLocation(stowCartMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForFloorLocationCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForFloorLocationCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getStowBagMetricsForFloorLocation = (nodeId, cycles, aisles, cycleIds, isStowBreakdownV2Enabled) => {
    const metricName = "getStowBagMetrics";

    const request = {
        groupBy: Resource.FLOOR_LOCATION_V2,
        filters: {
            NODE: [nodeId],
            AISLE: aisles
        },
        metrics: [
            BagMetric.PLANNED_BAG_COUNT,
            BagMetric.USED_BAG_COUNT
        ]
    }

    if (isStowBreakdownV2Enabled) {
        request.filters["STOW_BREAKDOWN_V2"] = [True]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForFloorLocationCallBegin());
            const startTime = Date.now();
            const stowBagMetricsMap = await getStowBagMetrics(request);
            if (stowBagMetricsMap) {
                dispatch(loadStowBagMetricsForFloorLocation(stowBagMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForFloorLocationCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForFloorLocationCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}

export const getNodeResourceDataForFloorLocation = (nodeId, nodeResourceType, aisle) => {
    const metricName = "getNodeResourceData";
    const request = {
        nodeId : nodeId,
        filters: {
            AISLE : aisle
        },
        nodeResourceType :nodeResourceType
    }
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForFloorLocationCallBegin());
            const startTime = Date.now();
            const nodeResources = await getNodeResourceData(request);
            if (nodeResources) {
                dispatch(loadNodeResourceDataForFloorLocation(nodeResources));
                publishTime(metricProcessName, metricName, startTime);
            }
        } catch (error) {
            dispatch(loadMetricsForFloorLocationCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
};

export const getStowBinMetricsForFloorLocation = (nodeId, cycles, aisles, cycleIds) => {
    const metricName = "getStowBinMetrics";

    const request = {
        groupBy: Resource.FLOOR_LOCATION_V2,
        filters: {
            NODE: [nodeId],
            AISLE: aisles
        },
        metrics: [BinMetric.BINS_COUNT_MISSING_OPEN_BAG]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = cycleIds;
    }

    return async (dispatch) => {
        try {
            dispatch(loadMetricsForFloorLocationCallBegin());
            const startTime = Date.now();
            const stowBinMetricsMap = await getStowBinMetricsForStowV2(request);
            if (stowBinMetricsMap) {
                dispatch(loadStowBinMetricsForFloorLocation(stowBinMetricsMap));
                publishTime(metricProcessName, metricName, startTime);
            } else {
                dispatch(loadMetricsForFloorLocationCallFailure());
                publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
            }
        } catch (error) {
            dispatch(loadMetricsForFloorLocationCallFailure());
            publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/FloorLocationActionsV2.js